export default __webpack_public_path__ + "static/media/getting_started_tags.22d517a8.png";